import request from '@/utils/request'
var http = process.env.BASE_API;
var big_data = "https://bigdata.q12301.com"

// 获取 iot 设置
export function iotSettingData(query) {
  return new Promise((resolve, reject) => {
    var returnData = request({
      url: big_data + '/big-data/iot/setting/',
      method: 'get',
      params: query
    })
    resolve(returnData)
  })
}

// 获取附加的客流信息
export function getIotScenicVillageTrend(query) {
  return new Promise((resolve, reject) => {
    var returnData = request({
      url: big_data + '/big-data/iot/villager_trend/',
      method: 'get',
      params: query
    })
    resolve(returnData)
  })
}

// 获取附加的实时游客数据
export function getIotScenicVillageRealData(query) {
	return request({
		url: big_data + '/big-data/iot/villager_real_data/',
		method: 'get',
		params: query
	})
}

// 获取附加的历史游客数据
export function getIotScenicHistoryData(query) {
	return request({
		url: big_data + '/big-data/iot/villager_history_data/',
		method: 'get',
		params: query
	})
}



// WEBPACK FOOTER //
// ./src/api/ScenicIotApi.js